import { render } from "./ObservationForm.vue?vue&type=template&id=6ef6a9e9&scoped=true"
import script from "./ObservationForm.vue?vue&type=script&lang=js"
export * from "./ObservationForm.vue?vue&type=script&lang=js"

import "./ObservationForm.vue?vue&type=style&index=0&id=6ef6a9e9&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ef6a9e9"]])

export default __exports__